import { ExtendsMainComponent } from '../extends/extends-main.component';

import { TermsOfServiceComponent } from './terms-of-service.component';
import { Compiler, Component, NgModule, OnInit, ViewChild, ViewContainerRef } from '@angular/core';

import { TokenManager } from '../../service/web-api.service';
import { WebApiService } from '../../service/web-api.service';
import { DocumentService } from '../../service/document.service';

import { ConfirmModalComponent } from '../confirm-modal/confirm-modal.component';
import { DocumentModalComponent } from '../document-modal/document-modal.component';

import { environment } from '../../../environments/environment';


declare let gtag: any; // グローバル変数gtagを解決

export class TermsOfServiceMainComponent extends ExtendsMainComponent {

  private confirmModalComponent: ConfirmModalComponent;
  private documentModal: DocumentModalComponent;

  private termsOfServiceComponent: TermsOfServiceComponent;
  private documentService: DocumentService;

  // 画面項目定義
  public consentDisabled: boolean;
  public documentInfoList: any[];
  public dispZ0001: string;
  public dispO0501: string;

  init(_termsOfServiceComponent: TermsOfServiceComponent, _confirmModalComponent: ConfirmModalComponent,
    _documentService: DocumentService, _documentModal: DocumentModalComponent) {

    this.config();

    this.termsOfServiceComponent = _termsOfServiceComponent;
    this.confirmModalComponent = _confirmModalComponent;
    this.documentInfoList = _termsOfServiceComponent.documentInfoList;
    this.documentService = _documentService;
    this.documentModal = _documentModal;
    this.consentDisabled = this.termsOfServiceComponent.consentDisabled;
    this.dispZ0001 = this.termsOfServiceComponent.dispZ0001;
    this.dispO0501 = this.termsOfServiceComponent.dispO0501;
  }

  /**
   * 同意する
   */
  agree() {
    this.locationAssign('/oauth/v2/authorization/verify?' + TokenManager.getToken());
  }

  /**
   * 同意する（既読登録）
   */
  agreeReadDocument() {
    this.documentService.execAuthRegisterReadDocument(this.documentInfoList).subscribe(result => {
      this.locationAssign('/oauth/v2/authorization/issue?' + TokenManager.getToken());
    });
  }

  /**
   * 同意しない
   */
  disagree() {
    let message = '';
    this.termsOfServiceComponent.translateService.get('NOT_AGREE_CONFIRMATION').subscribe((res: string) => {
      message = res;
    });
    let button = '';
    this.termsOfServiceComponent.translateService.get('NOT_AGREE').subscribe((res: string) => {
      button = res;
    });
    this.confirmModalComponent.showConfirmModal(message, button).subscribe(
      result => {
        if (result) {
          this.locationAssign('/oauth/v2/authorization/cancel?' + TokenManager.getToken());
        }
      }
    );
  }

  /**
   * 次へ
   */
  next() {
    // 引継ぎ項目
    this.termsOfServiceComponent.consentDisabled = this.consentDisabled;
    this.termsOfServiceComponent.pageNo++;

    // 画面切り替え
    this.termsOfServiceComponent.directInjection();
  }


  /**
   * イベント：戻る
   */
  back() {
    // 引継ぎ項目
    this.termsOfServiceComponent.pageNo--;

    // 画面切り替え
    this.termsOfServiceComponent.directInjection();
  }

  /**
   * イベント：利用規約リンク押下
   *
   * @param consentNo 利用規約No
   * @param total 総数
   */
  consent(consentNo: number, total: number) {

    this['consent' + consentNo] = true;

    // Disabled解除
    this.consentDisabled = false;
    for (let i = 1; i <= total; i++) {
      // 読まれていない利用規約が存在する場合
      if (!this['consent' + i]) {
        this.consentDisabled = true;
        break;
      }
    }
  }

  /**
* イベント：利用規約リンク押下（モーダルで規約表示）
*
* @param name 利用規約名
* @param url 利用規約のURL
* @param consentNo 何番目の規約か
* @param total 既読必須の場合、総数
*/
  consentWithModal(name: string, url: string, consentNo: number, total?: number) {

    // 画面側でこのフラグを利用してリンクの色を変更する
    this['consent' + consentNo] = true;

    // 規約モーダル表示
    this.documentModal.showModal(name, url).subscribe(
      result => {
        if (result) {
          // 何もしない
        }
      }
    );
    // モーダルの閉じるボタンで閉じなくても既読判定するように表示処理の外で既読判定する
    if (total !== undefined) {
      // Disabled解除
      this.consentDisabled = false;
      for (let i = 1; i <= total; i++) {
        // 読まれていない利用規約が存在する場合
        if (!this['consent' + i]) {
          this.consentDisabled = true;
          break;
        }
      }
    }
  }
}
